import React, { useCallback, useEffect, useState } from "react";
// import ApiService from "../../utils/ApiService";
import { useDispatch, useSelector } from "react-redux";

import { Button, Form, Input, Pagination, Row, Select, Spin } from "antd";
import AWS from "aws-sdk";
import moment from "moment";

import dayjs from "dayjs";
import Swal from "sweetalert2";

import categoryApi from "../../apis/Category.api";
import plutusApi from "../../apis/Plutus.api";
import LinkComponent from "../../components/layout/LinkComponent";
import UserManageNav from "../../components/userManageGroup/userManageNav";
import { setLoading } from "../../redux/store/common/commonDuck";
// import ApiService from "../../utils/ApiService";

AWS.config.update({
	accessKeyId: process.env.REACT_APP_S3_ACCESSKEYID,
	secretAccessKey: process.env.REACT_APP_S3_SECRETACCESSKEY,
	region: process.env.REACT_APP_S3_REGION,
});

const s3 = new AWS.S3();
// const api = new ApiService();

const UserAppPush = () => {
	// const history = useHistory();
	const dispatch = useDispatch();

	const user = useSelector((state) => state.auth.user);
	const isLoading = useSelector((state) => state.common.loading);
	const setIsLoading = (value) => dispatch(setLoading(value));

	// const [selectUserList, setSelectUserList] = useState([]);
	const selectUserList = [];
	const [pushInfo, setPushInfo] = useState({
		push_type: 2,
		influencer_id: user?.longlife_channel_id,
		targetType: 2,
		targetList: [],
		is_reservation: false,
		title: null,
		body: null,
		url: null,
		img: null,
		img_url: null,
		reservation_date: null,
		reservationDateStr: null,
		time: null,
		timeStr: null,
	}); // 앱 푸시 내용 (제목,내용,URL,이미지)
	const [valid, setValid] = useState(false); // 필수값 체크

	// const typeItems = [
	// 	{ label: "미션", value: 0 },
	// 	// { label: "전문가", value: 1 },
	// 	{ label: "공지사항", value: 2 },
	// 	{ label: "이벤트", value: 3 },
	// 	// { label: "시스템", value: 4 },
	// 	{ label: "기타", value: 5 },
	// ];

	const [linkType, setLinkType] = useState({ label: "없음", value: 0 });

	const linkTypeItems = [
		{ label: "없음", value: 0 },
		{ label: "소통글", value: 1 },
		{ label: "클래스", value: 2 },
		// { label: "공동구매", value: 3 },
		{ label: "문의글", value: 4 },
		{ label: "이벤트", value: 5 },
	];

	const pageSize = 5;
	const [currentPageNumber, setCurrentPageNumber] = useState(1);
	const [totalCount, setTotalCount] = useState(0);
	const [contentList, setContentList] = useState([]);

	const [checkedItem, setCheckedItem] = useState({});

	useEffect(() => {
		if (
			pushInfo.body &&
			pushInfo.body?.trim() &&
			(pushInfo.targetType === 1 ? selectUserList.length > 0 : true) &&
			(pushInfo.targetType === 2 ? pushInfo.influencer_id : true) &&
			(pushInfo.is_reservation
				? pushInfo.reservation_date &&
				  pushInfo.time &&
				  (moment().isSame(pushInfo.reservation_date, "day")
						? moment().hour() <= pushInfo.time.hour() &&
						  moment().minutes() < pushInfo.time.minutes()
						: true)
				: true)
		) {
			setValid(true);
		} else if (valid) {
			setValid(false);
		}
	}, [pushInfo, selectUserList]);

	// console.log(user);
	const sendPush = async () => {
		try {
			Swal.fire({
				customClass: "alert-custom",
				text: `위 내용으로 앱 푸시를 발송하시겠습니까?`,
				showCancelButton: true,
				confirmButtonText: "확인",
				cancelButtonText: "취소",
			}).then(async (result) => {
				console.log({
					push_type: pushInfo.push_type,
					// target_type: pushInfo.targetType,
					target_type: 2,
					title: pushInfo.title,
					body: pushInfo.body,
					// url: pushInfo.url,
					url: convertContentToLink(),
					is_reservation: pushInfo.is_reservation,
					// targetList: [`${user.partners_id}`],
					targetList: [user?.longlife_channel_id],
				});
				if (result.isConfirmed && !!pushInfo.body?.length) {
					setIsLoading(true);
					let param = {
						push_type: pushInfo.push_type,
						// target_type: pushInfo.targetType,
						target_type: 2,
						title: pushInfo.title,
						body: pushInfo.body,
						// url: pushInfo.url,
						url: convertContentToLink(),
						is_reservation: pushInfo.is_reservation,
						// targetList: [`${user.partners_id}`],
						targetList: [user?.longlife_channel_id],
					};
					console.log("send ==", param);
					// 대상 유형별 셋틸
					// if (pushInfo.targetType === 1) {
					// 	param["targetList"] = selectUserList;
					// } else if (pushInfo.targetType === 2) {
					// 	// param["targetList"] = [pushInfo.influencer_id];
					// 	param["targetList"] = [user.partners_id];
					// }
					// 예약일 관련 정보 설정
					if (pushInfo.is_reservation) {
						const reservationStr =
							`${pushInfo.reservationDateStr}${pushInfo.timeStr}`
								.replaceAll("-", "")
								.replaceAll(":", "");
						param["reservationDateStr"] = reservationStr;
					}
					// 이미지 관련 정보 설정
					if (pushInfo.img) {
						param[
							"img_url"
						] = `${process.env.REACT_APP_S3_LONGLIFE_HOST}/images/push/`;
					}

					const res = await plutusApi.sendPushForLonglife(param);
					if (res.code === 200) {
						await s3Upload(pushInfo.img, res.result.id);
						setIsLoading(false);
						alert("작성하신 내용으로 정삭적으로 발송되었습니다.");
						setPushInfo({
							push_type: 2,
							targetType: 0,
							targetList: [],
							is_reservation: false,
							title: null,
							body: null,
							url: null,
							img: null,
							img_url: null,
							reservation_date: null,
							reservationDateStr: null,
							time: null,
							timeStr: null,
						});
						setCheckedItem({});
						setLinkType({ label: "없음", value: 0 });
					} else if (res.code === 400) {
						setIsLoading(false);
						alert(
							"선택하신 대상 전부 해당 알림 전송 여부를 거부처리 하였습니다.\n다른 대상을 선택해주시길 바랍니다."
						);
						// setPushInfo({
						// 	push_type: 2,
						// 	targetType: 0,
						// 	targetList: [],
						// 	is_reservation: false,
						// 	title: null,
						// 	body: null,
						// 	url: null,
						// 	img: null,
						// 	img_url: null,
						// 	reservation_date: null,
						// 	reservationDateStr: null,
						// 	time: null,
						// 	timeStr: null,
						// });
					} else {
						console.log(res);
						setIsLoading(false);
						alert(
							"작성하신 내용으로 앱 푸시 전송에 실패하였습니다.\n다시 시도해주시거나 관리자에게 문의해주시길 바랍니다."
						);
					}
				}
			});
		} catch (e) {
			setIsLoading(false);
			console.log("sendPush send error", e);
		}
		setIsLoading(false);
	};

	const s3Upload = async (file, pushId) => {
		let s3Path = `images/push/${pushId}.jpg`;
		let params = {
			Bucket: process.env.REACT_APP_S3_LONGLIFE_BUCKETNAME,
			Key: s3Path,
			Body: file,
		};
		console.log(params);
		let res = await s3.putObject(params).promise();

		return res.$response.httpResponse.statusCode === 200;
	};

	const handleChange = (e) => {
		const { name, value } = e.target;
		setPushInfo({ ...pushInfo, [name]: value });
	};

	// const handlePreview = async (file) => {
	// 	let src = file.url;
	// 	if (!src) {
	// 		src = await new Promise((resolve) => {
	// 			const reader = new FileReader();
	// 			reader.readAsDataURL(file.originFileObj);
	// 			reader.onload = () => resolve(reader.result);
	// 		});
	// 	}
	// 	const image = new Image();
	// 	image.src = src;
	// 	const imgWindow = window.open(src);
	// 	imgWindow?.document.write(image.outerHTML);
	// };

	useEffect(() => {
		setCheckedItem({});
		if (currentPageNumber !== 1) {
			setCurrentPageNumber(1);
		} else {
			handleConnectLink();
		}
	}, [linkType]);

	useEffect(() => {
		handleConnectLink();
	}, [user, currentPageNumber]);

	const handleConnectLink = async () => {
		getContentCategory();
	};

	/**
	 * 링크 정보 가져오기
	 * @type {(function(): Promise<void>)|*}
	 */
	const getContentCategory = useCallback(async () => {
		setIsLoading(true);
		let param = {
			offset: (currentPageNumber - 1) * pageSize,
			pageSize: pageSize,
			categoryId: linkType.value,
			userId: user.id,
		};
		const res = await categoryApi.getContentsByCategory(param);
		if (res.code === 200) {
			// console.log(res.result);
			setTotalCount(res.result.totalCnt);
			setContentList(res.result?.contentDTOList);
		}
		setIsLoading(false);
	}, [currentPageNumber, linkType, user]);

	/**
	 * page 넘김
	 */
	const handleChangePagination = (pageNumber) => {
		// const currOffset = (pageNumber - 1) * pageSize;
		setCurrentPageNumber(pageNumber);
	};

	/**
	 * 클릭한 컨텐츠 link로 변환하기
	 * linkType ==> 0 - 없음 | 1 - 소통글 | 2 - 클래스 | 3 - 공동구매 | 4 - 영양제 추천
	 * 		1. 미션 페이지 이동
	 * 		mission/{미션아이디}/{미션 제목}
	 * 		2. 내건강 페이지 이동
	 * 		health/pedometer/record
	 * 		3. 소통글및 공지글 이동
	 * 		channelId/{채널아이디}/influencerId/{파트너스 아이디}/community/{소통글 아이디}
	 * 		4. 문의페이지 이동
	 * 		inquiry/{문의글 아이디}
	 * 		5. 영양제 추천 페이지 이동
	 * 		channelId/{채널아이디}/influencerId/{파트너스 아이디}/recommend_nutrients/{추천 영양제 아이디}
	 * 		6. 성분 페이지 이동
	 * 		channelId/{채널아이디}/influencerId/{파트너스 아이디}/ingredient/{성분 카테고리 영문명}
	 * 		7. 조합 페이지 이동
	 * 		channelId/{채널아이디}/influencerId/{파트너스 아이디}/combination/{조합게시글 아이디}
	 * 		8. 공동구매 페이지 이동
	 * 		StoreGroupBuying/{컨텐츠 아이디}
	 */
	const convertContentToLink = () => {
		let link = "";
		if (checkedItem.id) {
			// 3 소통글 및 공지글 이동
			if (linkType.value === 1) {
				link = `channelId/${checkedItem.channel_id}/influencerId/${checkedItem.influencer_id}/community/${checkedItem.id}`;
			}
			if (linkType.value === 2) {
				link = `mission/${checkedItem.id}/${checkedItem.head_copy}`;
			}
			if (linkType.value === 3 || linkType.value === 5) {
				link = `StoreGroupBuying/${checkedItem.id}`;
			}
			if (linkType.value === 4) {
				link = `channelId/${checkedItem.channel_id}/influencerId/${checkedItem.influencer_id}/recommend_nutrients/${checkedItem.id}`;
			}
			// setPushInfo({
			// 	...pushInfo,
			// 	url: link,
			// });
			console.log("convertContentToLink == ", link);
			return link;
		}
	};

	return (
		<div className="main-wrap">
			<div className="max-width-apply">
				<LinkComponent />

				<h1 className="main-title">회원 관리</h1>

				<UserManageNav />
				{isLoading && (
					<Spin style={{ margin: "auto", width: "100%", paddingTop: "2em" }} />
				)}
				<div className={`main-body`} style={{ alignItems: "center" }}>
					<Form
						labelCol={{ span: 4 }}
						wrapperCol={{ span: 22 }}
						style={{ width: "80%" }}
					>
						{/*<Form.Item label="유형" labelAlign="left" colon={false}>*/}
						{/*	<Select*/}
						{/*		options={typeItems}*/}
						{/*		onChange={(value) => {*/}
						{/*			setPushInfo({ ...pushInfo, push_type: value });*/}
						{/*		}}*/}
						{/*		value={pushInfo.push_type}*/}
						{/*		style={{ marginBottom: "1rem", width: "11rem" }}*/}
						{/*		disabled={isLoading}*/}
						{/*	/>*/}
						{/*</Form.Item>*/}
						{/*<Form.Item label="제목" labelAlign="left" colon={false}>*/}
						{/*	<Input*/}
						{/*		name="title"*/}
						{/*		value={pushInfo.title}*/}
						{/*		maxLength={100}*/}
						{/*		type={`text`}*/}
						{/*		placeholder={`제목을 입력해주세요 (선택)`}*/}
						{/*		onChange={handleChange}*/}
						{/*		disabled={isLoading}*/}
						{/*	/>*/}
						{/*</Form.Item>*/}
						<Form.Item
							label="내용"
							labelAlign="left"
							colon={false}
							required={true}
							className={`app-push-input`}
						>
							<Input.TextArea
								name="body"
								value={pushInfo.body}
								type={`text`}
								placeholder={`내용을 입력해주세요 (필수)`}
								required
								onChange={handleChange}
								showCount={true}
								maxLength={500}
								disabled={isLoading}
							/>
						</Form.Item>
						{/*<Form.Item label="이미지" labelAlign="left" colon={false}>*/}
						{/*	<Upload*/}
						{/*		listType="picture"*/}
						{/*		maxCount={1}*/}
						{/*		beforeUpload={(file) => false}*/}
						{/*		onChange={({ file }) => {*/}
						{/*			if (file?.status && file.status === "removed") {*/}
						{/*				setPushInfo({ ...pushInfo, img: null });*/}
						{/*			} else {*/}
						{/*				setPushInfo({ ...pushInfo, img: file });*/}
						{/*			}*/}
						{/*		}}*/}
						{/*		onPreview={handlePreview}*/}
						{/*		disabled={isLoading}*/}
						{/*	>*/}
						{/*		<Button loading={isLoading}>첨부이미지 업로드</Button>*/}
						{/*	</Upload>*/}
						{/*</Form.Item>*/}
						<Form.Item label="유입 링크" labelAlign="left" colon={false}>
							<div style={{ display: "flex", flexDirection: "column" }}>
								<div
									style={{
										display: "flex",
										alignItems: "center",
										justifyContent: "space-between",
									}}
								>
									<Select
										options={linkTypeItems}
										onChange={(value, option) => {
											setLinkType(option);
										}}
										value={linkType.label}
										style={{ marginBottom: "1rem", width: "11rem" }}
										disabled={isLoading}
									/>
									{checkedItem.id && (
										<div
											style={{
												display: "flex",
												// cursor: "pointer",
												padding: "0.5em 1em",
												gap: "0.5em",
												border: "solid 1px #ced4da",
												borderRadius: "5px",
												alignItems: "center",
												maxWidth: "400px",
											}}
										>
											<div
												style={{
													display: "flex",
													flexDirection: "column",
													width: "100%",
													gap: "0.3em",
												}}
											>
												<p
													style={{
														margin: 0,
														fontSize: "1.1em",
														lineHeight: 1,
														fontWeight: 600,
														whiteSpace: "nowrap",
														overflow: "hidden",
														textOverflow: "ellipsis",
													}}
												>
													{checkedItem.head_copy}
												</p>
												<p
													style={{
														margin: 0,
														fontSize: "0.9em",
														lineHeight: 1,
														fontWeight: 400,
														color: "#868e96",
													}}
												>
													{convertContentToLink()}
												</p>
											</div>
										</div>
									)}
								</div>
								{linkType.value !== 0 && (
									<>
										{contentList?.length ? (
											<div
												style={{
													display: "flex",
													flexDirection: "column",
													gap: "1em",
													padding: "1em 0",
												}}
											>
												{contentList?.map((item, idx) => {
													const newContent = item.content
														// ?.replaceAll(`<p>`, "")
														// ?.replaceAll(`<p></p>`, "")
														?.replaceAll(`</p><p>`, "")
														?.replaceAll(`<br>`, "");
													return (
														<div
															key={`content-list=${idx}`}
															style={{
																display: "flex",
																cursor: "pointer",
																padding: "1em",
																gap: "0.5em",
																border: "solid 1px #ced4da",
																borderRadius: "5px",
															}}
															onClick={(e) => {
																e.preventDefault();
																setCheckedItem(item);
															}}
														>
															<img
																src={`/assets/images/login/check${
																	item.id === checkedItem?.id ? "-active" : ""
																}.png`}
																alt={`링크 체크`}
																style={{
																	height: "1.2em",
																	width: "1.2em",
																}}
															/>
															<div
																style={{
																	width: "calc(100% - 1.5em)",
																	display: "flex",
																	flexDirection: "column",
																	gap: "0.5em",
																}}
															>
																{item.head_copy && (
																	<p
																		style={{
																			margin: 0,
																			fontSize: "1.1em",
																			lineHeight: 1,
																			fontWeight: "600",
																			whiteSpace: "nowrap",
																			overflow: "hidden",
																			textOverflow: "ellipsis",
																		}}
																	>
																		{item.head_copy}
																	</p>
																)}
																<p
																	style={{
																		margin: 0,
																		fontSize: "0.9em",
																		lineHeight: 1,
																		fontWeight: 400,
																		color: "#868e96",
																	}}
																>
																	{dayjs(item.created_at).format("YYYY.MM.DD")}
																</p>
																{linkType.value !== 2 && newContent && (
																	<div
																		className={`community-app-push-body-div`}
																	>
																		<p
																			dangerouslySetInnerHTML={{
																				__html: newContent,
																			}}
																		/>
																	</div>
																)}
															</div>
														</div>
													);
												})}
												<Pagination
													className="report-pagination-wrap"
													showSizeChanger={false}
													current={currentPageNumber}
													pageSize={pageSize}
													total={totalCount}
													onChange={handleChangePagination}
												/>
											</div>
										) : (
											<Row
												align={"middle"}
												style={{
													width: "100%",
													flexDirection: "column",
													padding: "5em 0",
												}}
											>
												<img
													src={`/assets/images/warning.png`}
													alt={`warning-icon`}
													style={{
														width: "3em",
														height: "auto",
													}}
												/>
												<p
													style={{
														marginTop: "1em",
														color: "#adb5bd",
														fontSize: "1.1em",
														fontWeight: 500,
													}}
												>
													작성글이 없습니다.
												</p>
											</Row>
										)}
									</>
								)}
							</div>
						</Form.Item>
						<div
							style={{
								width: "100%",
								display: "flex",
								justifyContent: "center",
								alignItems: "center",
							}}
						>
							<Button
								size={"small"}
								className={`edit-success-btn`}
								style={{
									borderRadius: "5px",
									backgroundColor: "#117ffa",
									// width: "50%",
									margin: "1em auto",
									padding: "0.3em 1.5em",
									height: "auto",
								}}
								// disabled={!valid}
								onClick={sendPush}
								loading={isLoading}
							>
								전송
							</Button>
						</div>
					</Form>
				</div>
			</div>
		</div>
	);
};
export default UserAppPush;
